import { PlayerUserDetailSkeleton } from "components/Skeleton/PlayerUsersPage/PlayerUserDetailSkeleton";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import client from "libs/client";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import SkeletonBox from "ui-kit/src/Skeleton/SkeletonBox";
import NotFoundPage from "./errorPages/NotFoundPage";
import { DiscoverUserDetail } from "features/discover/DiscoverUserDetail";
import { DiscoverUserGetResponse } from "libs/apiClient";
import { DiscoverBreadcrumbs } from "features/discover/DiscoverBreadcrumbs";
import { useUserData } from "features/userData/context";
import { useToast } from "ui-kit";

export function DiscoverUserPage() {
	const { id } = useParams();
	const [showModal, setShowModal] = useState(false);
	const currentUser = useUserData();
	const { addErrorToast } = useToast();

	useEffect(() => {
		setScrollBehavior();
	}, []);

	const { data: response, isLoading, error } = client.getDiscoverUser.useQuery({ id: parseInt(id || "") }, { queryKey: ["discoverUserDetail"] });

	const impersonateMutation = client.postDiscoverUserImpersonate.useMutation({
		onSuccess: (res) => {
			const token = res?.data.token;
			if (token === undefined || token === null) {
				addErrorToast("Failed to impersonate user");
			} else {
				const discoverUrl =
					import.meta.env.VITE_APP_ENV === "review"
						? window.location.origin.replace("admin", "discover")
						: import.meta.env.VITE_DISCOVER_URL;
				window.open(`${discoverUrl}/login?token=${token}`, "_blank", "noopener,noreferrer");
			}
		},
		onError: () => {
			addErrorToast("Failed to impersonate user");
		},
	});

	if (error) {
		const code = error?.response.status;

		if (code === 404) {
			return (
				<div>
					<NotFoundPage />
				</div>
			);
		}
	}

	const data: DiscoverUserGetResponse = response?.data || ({} as DiscoverUserGetResponse);

	return (
		<div className="discover-container">
			<div className="pageHeading">
				{isLoading ? (
					<SkeletonBox style={{ width: "300px", height: "32px", margin: "35px 0 35px 0" }} />
				) : (
					<>
						<DiscoverBreadcrumbs
							items={[
								{
									label: "Users",
									route: "/discover/user",
								},
								{
									label: `${data.firstName} ${data.lastName}`,
									note: data.id,
								},
							]}
						/>
						<div style={{ display: "flex", gap: "10px" }}>
							<div className="activateButton" onClick={() => setShowModal(true)}>
								{data?.isActive ? "Deactivate" : "Activate"}
							</div>
							{(currentUser.isSuperAdmin || currentUser.permissions.some((p) => p.permission === "log_in_as_user" && p.resource === "log_in_as_user")) && data?.id && (
								<div className="activateButton" onClick={() => impersonateMutation.mutate({ id: data.id })}>
									Log in as this user
								</div>
							)}
						</div>
					</>
				)}
			</div>
			{isLoading ? <PlayerUserDetailSkeleton /> : <DiscoverUserDetail userData={data} showModal={showModal} setShowModal={setShowModal} />}
		</div>
	);
}
